import { render, staticRenderFns } from "./PrizesAddUpdate.vue?vue&type=template&id=09aaaf08&"
import script from "./PrizesAddUpdate.vue?vue&type=script&lang=js&"
export * from "./PrizesAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PrizesAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports